import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { MainCampaignActions } from "../../main-campaign.actions";
import { mainCampaignServices } from "../../main-campaign.services";
import { GlobalService } from "../../../global.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-change-plan-step-1',
  templateUrl: './change-plan-step-1.component.html',
  styleUrls: ['./change-plan-step-1.component.scss']
})
export class ChangePlanStep1Component implements OnInit {

  form: FormGroup;
  initialData: any;
  option: any;
  broad_plan: any;
  step1: any = {
    typeOfNumber: 1,
    typeOfPlan: 2,
    network: "",
    acountNo: ""
  };
  listReasonPlan = [
    { id: 1, name: 'My Own Number' },
    { id: 2, name: 'Not My Number' },
  ];
  listTypeOfPlan = [
    { id: 2, name: 'POSTPAID' },
    { id: 3, name: 'PREPAID' },
  ];
  subscription: any;
  listNetwork: any;


  constructor(private store: Store<any>,
    private fb: FormBuilder,
    private mainCampaignActions: MainCampaignActions,
    private mainCampaignServices: mainCampaignServices,
    private globalService: GlobalService) {

    this.subscription = store.select("mainCampaign").subscribe(store => {
      this.option = store.option;
      this.broad_plan = store.broad_plan;
      this.step1 = store.step1;
      this.step1.typeOfNumber = store.step1.typeOfNumber === 2 ? 'notMyOwn' : 'myOwn';
      this.step1.typeOfPlan = 'postPaid';
    });


    //form
    this.form = fb.group({
      acountNo: [(this.initialData) ? this.initialData.acountNo : "", Validators.compose([this.globalService.isPhone])],
      typeOfNumber: [(this.initialData) ? this.initialData.typeOfNumber : 1]
    })

    var dataSession = this.globalService.getSession("mainApplication");

    if (dataSession.step1) {
      if (dataSession.step1.acountNo) {
        this.form.get('acountNo').setValue(dataSession.step1.acountNo);
      }
    }
  }


  ngOnInit() {

  }


  getNetwork() {
    this.mainCampaignServices.getListNetwork().subscribe(res => {
      this.listNetwork = res.network;
    })
  }

  onClickNext() {
    //save session

    this.step1.acountNo = this.form.get("acountNo").value;
    if (this.step1.typeOfNumber === 'myOwn') {
      this.step1.typeOfNumber = 1;
    } else if (this.step1.typeOfNumber === 'notMyOwn') {
      this.step1.typeOfNumber = 2;
    }

    if (this.step1.typeOfPlan === 'postPaid') {
      this.step1.typeOfPlan = 2;
    } else if (this.step1.typeOfPlan === 'prePaid') {
      this.step1.typeOfPlan = 3;
    }

    let newValueSession = {
      option: this.option,
      broad_plan: this.globalService.getSession('broad_plan'),
      step1: Object.assign({}, this.step1)
    };

    // console.log(newValueSession)

    newValueSession = Object.assign({}, this.globalService.getSession("mainApplication"), newValueSession);
    this.globalService.setSession("mainApplication", newValueSession);

    // next
    this.store.dispatch(this.mainCampaignActions.updateStep1(this.step1));
  }

  onClickBack() {
    this.store.dispatch(this.mainCampaignActions.stepBack());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
